// import { useState, useRef, useEffect, useCallback } from "react";
// import {
//   Form,
//   Input,
//   Table,
//   Button,
//   Space,
//   DatePicker,
//   Select,
//   Row,
//   Col,
//   InputNumber,
//   message,
//   Modal,
// } from "antd";
// import { DeleteOutlined } from "@ant-design/icons";
// import moment from "moment";
// import axios from "axios";
// import { API, Headers } from "../../Config";
// import { useSelector } from "react-redux";

// const FormModalJournal = (props) => {
//   const Auth = useSelector((state) => state.Auth.user);
//   const formRef = useRef();
//   const [form] = Form.useForm();
//   const dateFormat = "DD/MM/YYYY";

//   // Initialize data based on mode
//   const initialData =
//     props.mode === "post"
//       ? [
//           {
//             key: 1,
//             account_no: null,
//             description: "",
//             amount_cr: 0,
//             amount_dr: 0,
//             activeInput: null,
//           },
//         ]
//       : props.item?.id
//       ? props.item.voucherDetails.map((item) => ({
//           key: item.key,
//           account_no: item.account_no,
//           description: item.description,
//           amount_cr: item.amount_cr || 0,
//           amount_dr: item.amount_dr || 0,
//           activeInput: item.amount_cr
//             ? "credit"
//             : item.amount_dr
//             ? "debit"
//             : null,
//         }))
//       : [];

//   const [dataSource, setDataSource] = useState(initialData);
//   const [paymentData, setPaymentData] = useState([]);
//   const [totalCr, setTotalCr] = useState(
//     props.mode === "put" ? props.item?.cr_total : 0
//   );
//   const [totalDr, setTotalDr] = useState(
//     props.mode === "put" ? props.item?.dr_total : 0
//   );
//   const [loading, setLoading] = useState(false);

//   // Memoized function to render debit amount
//   const renderDebitAmount = useCallback(
//     (record) => {
//       if (!paymentData.length) return record.amount_dr;

//       const currentPaymentInfo = paymentData.find((item) =>
//         item.awbPaymentDetails?.some(
//           (detail) => detail.account_no === record.account_no
//         )
//       );

//       return currentPaymentInfo
//         ? currentPaymentInfo.awbPaymentDetails.find(
//             (detail) => detail.account_no === record.account_no
//           )?.amount ?? record.amount_dr
//         : record.amount_dr;
//     },
//     [paymentData]
//   );

//   // Calculate totals function
//   const calculateTotals = useCallback(
//     (data) => {
//       const newTotalCr = data.reduce(
//         (acc, item) => acc + (Number(item.amount_cr) || 0),
//         0
//       );
//       const newTotalDr = data.reduce(
//         (acc, item) => acc + (Number(renderDebitAmount(item)) || 0),
//         0
//       );

//       setTotalCr(newTotalCr);
//       setTotalDr(newTotalDr);

//       form.setFieldsValue({
//         cr_total: newTotalCr,
//         dr_total: newTotalDr,
//       });
//     },
//     [renderDebitAmount, form]
//   );

//   // Data fetching
//   const fetchData = useCallback(async () => {
//     try {
//       const response = await axios.get(
//         `${API.BASR_URL}${API.AWB_PAYMENT_LIST}?order=DESC&page=1&take=10`,
//         { headers: Headers() }
//       );
//       if (response.status === 200) {
//         setPaymentData(response.data?.data || []);
//       }
//     } catch (error) {
//       message.error("Failed to fetch payment data");
//     }
//   }, []);

//   // Initial setup
//   useEffect(() => {
//     fetchData();
//   }, [fetchData]);

//   // Event handlers
//   const handleChangeValueSet = useCallback(
//     (value, key, field) => {
//       setDataSource((prev) => {
//         const newDataSource = prev.map((val) => {
//           if (val.key === key) {
//             const updates = { [field]: value };

//             // Update active input logic
//             if (field === "amount_dr" && value !== 0) {
//               updates.activeInput = "debit";
//             } else if (field === "amount_cr" && value !== 0) {
//               updates.activeInput = "credit";
//             } else {
//               updates.activeInput = null;
//             }

//             // Reset opposite field when one is active
//             if (updates.activeInput === "debit") {
//               updates.amount_cr = 0;
//             } else if (updates.activeInput === "credit") {
//               updates.amount_dr = 0;
//             }

//             // Handle account number update for debit amount
//             if (field === "account_no") {
//               updates.amount_dr = renderDebitAmount({
//                 ...val,
//                 account_no: value,
//               });
//             }

//             return { ...val, ...updates };
//           }
//           return val;
//         });

//         calculateTotals(newDataSource);
//         return newDataSource;
//       });
//     },
//     [renderDebitAmount, calculateTotals]
//   );

//   const handleAddProduct = useCallback(() => {
//     setDataSource((prev) => {
//       const newDataSource = [
//         ...prev,
//         {
//           key: prev.length + 1,
//           account_no: null,
//           description: "",
//           amount_cr: 0,
//           amount_dr: 0,
//           activeInput: null,
//         },
//       ];

//       calculateTotals(newDataSource);
//       return newDataSource;
//     });
//   }, [calculateTotals]);

//   const handleRemoveProduct = useCallback(
//     (key) => {
//       setDataSource((prev) => {
//         const newDataSource = prev.filter((item) => item.key !== key);
//         calculateTotals(newDataSource);
//         return newDataSource;
//       });
//     },
//     [calculateTotals]
//   );

//   const onFinish = async (values) => {
//     if (
//       props.page_mode === "JV" &&
//       Number(values.cr_total) !== Number(values.dr_total)
//     ) {
//       message.error("CR Total and DR Total must be equal");
//       return;
//     }

//     setLoading(true);
//     try {
//       const payload = {
//         voucher_date: values.voucher_date,
//         voucher_type: props.page_mode,
//         account_no: values.account_no ?? null,
//         description: values.description,
//         userid: Number(Auth.id),
//         cr_total: Number(totalCr),
//         dr_total: Number(totalDr),
//         voucherItems: dataSource,
//       };

//       const url = `${API.BASR_URL}${
//         props.mode === "post"
//           ? API.VOUCHER_ACTIONS + props.page_mode
//           : API.VOUCHER_ACTIONS + props.item.id
//       }`;
//       console.log("payload-->");
//       console.log(payload);
//       console.log("payload-->");
//       return;
//       const response = await axios({
//         method: props.mode,
//         url,
//         headers: Headers(),
//         data: payload,
//       });

//       if ([200, 201].includes(response.status)) {
//         message.success("Success");
//         props.onchange?.();
//         props.onClose?.();
//       }
//     } catch (error) {
//       message.error("Operation failed");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const columns = [
//     {
//       title: "#",
//       dataIndex: "slno",
//       key: "slno",
//       width: 30,
//       align: "center",
//       fixed: "left",
//       render: (_, __, index) => index + 1,
//     },
//     {
//       title: "Account",
//       dataIndex: "account_no",
//       key: "account_no",
//       width: 300,
//       fixed: "left",
//       render: (text, record) => (
//         <Form.Item
//           style={{ margin: 0 }}
//           name={["list", record.key, "account_no"]}
//           initialValue={text}
//           rules={[{ required: true, message: "Required" }]}
//         >
//           <Select
//             bordered={false}
//             showSearch
//             allowClear
//             style={{ width: "100%" }}
//             value={record.account_no}
//             onChange={(value) =>
//               handleChangeValueSet(value, record.key, "account_no")
//             }
//             filterOption={(input, option) => {
//               const searchText = input.toLowerCase();
//               const optionText = option.children.toString().toLowerCase();
//               return optionText.includes(searchText);
//             }}
//           >
//             {props.accounts?.map((item) => (
//               <Select.Option key={item.account_no} value={item.account_no}>
//                 {item.account_no} - {item.account_name}
//               </Select.Option>
//             ))}
//           </Select>
//         </Form.Item>
//       ),
//     },
//     {
//       title: "Description",
//       dataIndex: "description",
//       key: "description",
//       width: 250,
//       render: (text, record) => (
//         <Input.TextArea
//           autoSize={{ minRows: 1, maxRows: 6 }}
//           bordered={false}
//           value={record.description}
//           onChange={(e) =>
//             handleChangeValueSet(e.target.value, record.key, "description")
//           }
//         />
//       ),
//     },
//     {
//       title: "Debit Amount",
//       dataIndex: "amount_dr",
//       key: "amount_dr",
//       width: 250,
//       render: (_, record) => (
//         <InputNumber
//           style={{ width: "100%" }}
//           bordered={false}
//           value={record.amount_dr}
//           disabled={record.activeInput === "credit"}
//           onChange={(value) =>
//             handleChangeValueSet(value, record.key, "amount_dr")
//           }
//         />
//       ),
//     },
//     {
//       title: "Credit Amount",
//       dataIndex: "amount_cr",
//       key: "amount_cr",
//       visible: props.columnsVisible?.amount_cr,
//       width: 150,
//       render: (_, record) => (
//         <InputNumber
//           style={{ width: "100%" }}
//           bordered={false}
//           value={record.amount_cr}
//           disabled={record.activeInput === "debit"}
//           onChange={(value) =>
//             handleChangeValueSet(value, record.key, "amount_cr")
//           }
//         />
//       ),
//     },
//     {
//       title: " ",
//       key: "action",
//       width: 30,
//       fixed: "right",
//       render: (_, record) => (
//         <Space>
//           <DeleteOutlined
//             onClick={() =>
//               dataSource.length > 1 && handleRemoveProduct(record.key)
//             }
//             style={{ cursor: "pointer" }}
//           />
//         </Space>
//       ),
//     },
//   ];

//   const renderSummary = () => (
//     <Table.Summary.Row style={{ height: 50 }}>
//       <Table.Summary.Cell index={0} />
//       <Table.Summary.Cell index={1}>
//         <Button type="link" onClick={handleAddProduct} style={{ padding: 0 }}>
//           Add New
//         </Button>
//       </Table.Summary.Cell>
//       <Table.Summary.Cell index={2}>
//         <strong>Total</strong>
//       </Table.Summary.Cell>
//       <Table.Summary.Cell index={3}>
//         <Form.Item name="dr_total" style={{ margin: 0 }}>
//           <strong>{Number(totalDr).toFixed(2)}</strong>
//         </Form.Item>
//       </Table.Summary.Cell>
//       <Table.Summary.Cell index={4}>
//         <Form.Item name="cr_total" style={{ margin: 0 }}>
//           <strong>{Number(totalCr).toFixed(2)}</strong>
//         </Form.Item>
//       </Table.Summary.Cell>
//       <Table.Summary.Cell index={5} />
//     </Table.Summary.Row>
//   );

//   return (
//     <Modal
//       title={props.columnsVisible?.page}
//       open={props.visible}
//       onCancel={props.onClose}
//       width={1000}
//       footer={false}
//     >
//       <Form
//         form={form}
//         ref={formRef}
//         onFinish={onFinish}
//         initialValues={{
//           voucher_date:
//             props.mode === "post" ? moment() : moment(props.item?.voucher_date),
//           account_no: props.item?.account_no,
//           description: props.item?.description,
//           cr_total: props.item?.cr_total,
//           dr_total: props.item?.dr_total,
//         }}
//       >
//         <Row gutter={[16, 16]}>
//           <Col xs={24} md={12}>
//             {props.page_mode !== "JV" && (
//               <Form.Item
//                 label="Account"
//                 name="account_no"
//                 rules={[{ required: true }]}
//                 labelCol={{ span: 7 }}
//                 wrapperCol={{ span: 16 }}
//               >
//                 <Select
//                   size="small"
//                   showSearch
//                   allowClear
//                   filterOption={(input, option) => {
//                     const searchText = input.toLowerCase();
//                     const optionText = option.children.toString().toLowerCase();
//                     return optionText.includes(searchText);
//                   }}
//                 >
//                   {props.accounts?.map((item) => (
//                     <Select.Option
//                       key={item.account_no}
//                       value={item.account_no}
//                     >
//                       {item.account_no} - {item.account_name}
//                     </Select.Option>
//                   ))}
//                 </Select>
//               </Form.Item>
//             )}
//             <Form.Item
//               label="Description"
//               name="description"
//               // rules={[{ required: true }]}
//               labelCol={{ span: 7 }}
//               wrapperCol={{ span: 16 }}
//             >
//               <Input.TextArea rows={2} size="small" />
//             </Form.Item>
//           </Col>
//           <Col xs={24} md={12}>
//             <Form.Item
//               label="Voucher Date"
//               name="voucher_date"
//               rules={[{ required: true }]}
//               labelCol={{ span: 7 }}
//               wrapperCol={{ span: 7 }}
//             >
//               <DatePicker
//                 size="small"
//                 format={dateFormat}
//                 style={{ width: "100%" }}
//               />
//             </Form.Item>
//           </Col>
//         </Row>

//         <Table
//           dataSource={dataSource}
//           columns={columns.filter((col) => col.visible !== false)}
//           pagination={false}
//           size="small"
//           bordered
//           summary={renderSummary}
//           scroll={{ x: true }}
//         />

//         <Row justify="end" gutter={[16, 0]} style={{ marginTop: 16 }}>
//           <Col>
//             <Button onClick={props.onClose}>Cancel</Button>
//           </Col>
//           <Col>
//             <Button type="primary" htmlType="submit" loading={loading}>
//               {props.mode === "post" ? "Save" : "Update"}
//             </Button>
//           </Col>
//         </Row>
//       </Form>
//     </Modal>
//   );
// };

// export default FormModalJournal;

import { useState, useRef, useEffect, useCallback } from "react";
import {
  Form,
  Input,
  Table,
  Button,
  Space,
  DatePicker,
  Select,
  Row,
  Col,
  InputNumber,
  message,
  Modal,
} from "antd";
import { DeleteOutlined } from "@ant-design/icons";
import moment from "moment";
import axios from "axios";
import { API, Headers } from "../../Config";
import { useSelector } from "react-redux";

const FormModalJournal = (props) => {
  const Auth = useSelector((state) => state.Auth.user);
  const formRef = useRef();
  const [form] = Form.useForm();
  const dateFormat = "DD/MM/YYYY";

  // Initialize data based on mode
  const getInitialData = () => {
    if (props.mode === "post") {
      return [
        {
          key: 1,
          account_no: null,
          description: "",
          amount_cr: null,
          amount_dr: null,
          activeInput: null,
        },
      ];
    }

    if (props.item?.id && props.item.voucherDetails) {
      return props.item.voucherDetails.map((item, index) => ({
        key: item.key || index + 1,
        account_no: item.account_no,
        description: item.description,
        amount_cr: item.amount_cr || null,
        amount_dr: item.amount_dr || null,
        activeInput:
          item.amount_cr > 0 ? "credit" : item.amount_dr > 0 ? "debit" : null,
      }));
    }

    return [];
  };

  const [dataSource, setDataSource] = useState(getInitialData);
  const [paymentData, setPaymentData] = useState([]);
  const [totalCr, setTotalCr] = useState(
    props.mode === "put" ? props.item?.cr_total || 0 : 0
  );
  const [totalDr, setTotalDr] = useState(
    props.mode === "put" ? props.item?.dr_total || 0 : 0
  );
  const [loading, setLoading] = useState(false);

  // Get payment amount for account
  const getPaymentAmount = useCallback(
    (accountNo) => {
      if (!paymentData.length || !accountNo) return 0;

      const paymentInfo = paymentData.find((item) =>
        item.awbPaymentDetails?.some(
          (detail) => detail.account_no === accountNo
        )
      );

      if (paymentInfo) {
        const detail = paymentInfo.awbPaymentDetails.find(
          (detail) => detail.account_no === accountNo
        );
        return detail?.amount || 0;
      }

      return 0;
    },
    [paymentData]
  );

  // Calculate totals
  const calculateTotals = useCallback(
    (data) => {
      const newTotalCr = data.reduce(
        (acc, item) => acc + (Number(item.amount_cr) || 0),
        0
      );
      const newTotalDr = data.reduce(
        (acc, item) => acc + (Number(item.amount_dr) || 0),
        0
      );

      setTotalCr(newTotalCr);
      setTotalDr(newTotalDr);

      form.setFieldsValue({
        cr_total: newTotalCr,
        dr_total: newTotalDr,
      });
    },
    [form]
  );

  // Fetch payment data
  const fetchPaymentData = useCallback(async () => {
    try {
      const response = await axios.get(
        `${API.BASR_URL}${API.AWB_PAYMENT_LIST}?order=DESC&page=1&take=10`,
        { headers: Headers() }
      );
      if (response.status === 200) {
        setPaymentData(response.data?.data || []);
      }
    } catch (error) {
      console.error("Failed to fetch payment data:", error);
      message.error("Failed to fetch payment data");
    }
  }, []);

  // Handle field value changes
  const handleFieldChange = useCallback(
    (value, key, field) => {
      setDataSource((prevData) => {
        const newData = prevData.map((item) => {
          if (item.key !== key) return item;

          const updatedItem = { ...item };

          if (field === "account_no") {
            updatedItem.account_no = value;

            // Set debit amount from payment data if available
            const paymentAmount = getPaymentAmount(value);
            if (
              paymentAmount > 0 &&
              (!updatedItem.amount_dr || updatedItem.amount_dr === 0)
            ) {
              updatedItem.amount_dr = paymentAmount;
              updatedItem.activeInput = "debit";
              updatedItem.amount_cr = null;
            }
          } else if (field === "amount_dr") {
            updatedItem.amount_dr = value;
            if (value && value > 0) {
              updatedItem.activeInput = "debit";
              updatedItem.amount_cr = null;
            } else if (!value || value === 0) {
              updatedItem.activeInput = null;
            }
          } else if (field === "amount_cr") {
            updatedItem.amount_cr = value;
            if (value && value > 0) {
              updatedItem.activeInput = "credit";
              updatedItem.amount_dr = null;
            } else if (!value || value === 0) {
              updatedItem.activeInput = null;
            }
          } else {
            updatedItem[field] = value;
          }

          return updatedItem;
        });

        calculateTotals(newData);
        return newData;
      });
    },
    [getPaymentAmount, calculateTotals]
  );

  // Add new row
  const handleAddRow = useCallback(() => {
    const newKey = Math.max(...dataSource.map((item) => item.key), 0) + 1;
    const newRow = {
      key: newKey,
      account_no: null,
      description: "",
      amount_cr: null,
      amount_dr: null,
      activeInput: null,
    };

    setDataSource((prevData) => {
      const newData = [...prevData, newRow];
      calculateTotals(newData);
      return newData;
    });
  }, [dataSource, calculateTotals]);

  // Remove row
  const handleRemoveRow = useCallback(
    (key) => {
      if (dataSource.length <= 1) {
        message.warning("At least one row is required");
        return;
      }

      setDataSource((prevData) => {
        const newData = prevData.filter((item) => item.key !== key);
        calculateTotals(newData);
        return newData;
      });
    },
    [dataSource.length, calculateTotals]
  );

  // Form submission
  const handleSubmit = async (values) => {
    // Validation
    const hasEmptyAccount = dataSource.some((item) => !item.account_no);
    if (hasEmptyAccount) {
      message.error("Please select account for all rows");
      return;
    }

    const hasEmptyAmounts = dataSource.some(
      (item) =>
        (!item.amount_cr || item.amount_cr === 0) &&
        (!item.amount_dr || item.amount_dr === 0)
    );
    if (hasEmptyAmounts) {
      message.error("Please enter amount for all rows");
      return;
    }

    // Journal Voucher specific validation
    if (props.page_mode === "JV" && Number(totalCr) !== Number(totalDr)) {
      message.error(
        "Credit Total and Debit Total must be equal for Journal Voucher"
      );
      return;
    }

    setLoading(true);
    try {
      const payload = {
        voucher_date: values.voucher_date,
        voucher_type: props.page_mode,
        account_no: values.account_no || null,
        description: values.description,
        userid: Number(Auth.id),
        cr_total: Number(totalCr),
        dr_total: Number(totalDr),
        voucherItems: dataSource.map((item) => ({
          key: item.key,
          account_no: item.account_no,
          description: item.description,
          amount_cr: Number(item.amount_cr) || 0,
          amount_dr: Number(item.amount_dr) || 0,
        })),
      };

      const url = `${API.BASR_URL}${
        props.mode === "post"
          ? API.VOUCHER_ACTIONS + props.page_mode
          : API.VOUCHER_ACTIONS + props.item.id
      }`;

      const response = await axios({
        method: props.mode,
        url,
        headers: Headers(),
        data: payload,
      });

      if ([200, 201].includes(response.status)) {
        message.success(
          `Voucher ${
            props.mode === "post" ? "created" : "updated"
          } successfully`
        );
        props.onchange?.();
        props.onClose?.();
      }
    } catch (error) {
      console.error("Operation failed:", error);
      message.error(error.response?.data?.message || "Operation failed");
    } finally {
      setLoading(false);
    }
  };

  // Initialize data on component mount
  useEffect(() => {
    fetchPaymentData();
  }, [fetchPaymentData]);

  // Recalculate totals when dataSource changes
  useEffect(() => {
    calculateTotals(dataSource);
  }, [dataSource, calculateTotals]);

  const columns = [
    {
      title: "#",
      dataIndex: "slno",
      key: "slno",
      width: 50,
      align: "center",
      fixed: "left",
      render: (_, __, index) => index + 1,
    },
    {
      title: "Account",
      dataIndex: "account_no",
      key: "account_no",
      width: 400,
      fixed: "left",
      render: (text, record) => (
        <Select
          bordered={false}
          showSearch
          allowClear
          style={{ width: "100%" }}
          value={record.account_no}
          placeholder="Select Account"
          onChange={(value) =>
            handleFieldChange(value, record.key, "account_no")
          }
          filterOption={(input, option) => {
            const searchText = input.toLowerCase();
            const optionText = option.children.toString().toLowerCase();
            return optionText.includes(searchText);
          }}
        >
          {props.accounts?.map((item) => (
            <Select.Option key={item.account_no} value={item.account_no}>
              {item.account_no} - {item.account_name}
            </Select.Option>
          ))}
        </Select>
      ),
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
      width: 250,
      render: (text, record) => (
        <Input.TextArea
          autoSize={{ minRows: 1, maxRows: 3 }}
          bordered={false}
          value={record.description}
          placeholder="Enter description"
          onChange={(e) =>
            handleFieldChange(e.target.value, record.key, "description")
          }
        />
      ),
    },
    {
      title: "Debit Amount",
      dataIndex: "amount_dr",
      key: "amount_dr",
      width: 150,
      render: (_, record) => (
        <InputNumber
          style={{ width: "100%" }}
          bordered={false}
          value={record.amount_dr}
          placeholder="0.00"
          min={0}
          precision={2}
          disabled={record.activeInput === "credit"}
          onChange={(value) =>
            handleFieldChange(value, record.key, "amount_dr")
          }
        />
      ),
    },
    {
      title: "Credit Amount",
      dataIndex: "amount_cr",
      key: "amount_cr",
      width: 150,
      render: (_, record) => (
        <InputNumber
          style={{ width: "100%" }}
          bordered={false}
          value={record.amount_cr}
          placeholder="0.00"
          min={0}
          precision={2}
          disabled={record.activeInput === "debit"}
          onChange={(value) =>
            handleFieldChange(value, record.key, "amount_cr")
          }
        />
      ),
    },
    {
      title: "Action",
      key: "action",
      width: 60,
      fixed: "right",
      render: (_, record) => (
        <Space>
          <DeleteOutlined
            onClick={() => handleRemoveRow(record.key)}
            style={{
              cursor: dataSource.length > 1 ? "pointer" : "not-allowed",
              color: dataSource.length > 1 ? "#ff4d4f" : "#d9d9d9",
            }}
          />
        </Space>
      ),
    },
  ];

  // Filter columns based on visibility
  const visibleColumns = columns.filter((col) => {
    if (col.key === "amount_cr") {
      return props.columnsVisible?.amount_cr !== false;
    }
    return true;
  });

  const renderSummary = () => (
    <Table.Summary.Row style={{ backgroundColor: "#fafafa" }}>
      <Table.Summary.Cell index={0} />
      <Table.Summary.Cell index={1}>
        <Button
          type="link"
          onClick={handleAddRow}
          style={{ padding: 0, fontWeight: "bold" }}
        >
          + Add Row
        </Button>
      </Table.Summary.Cell>
      <Table.Summary.Cell index={2}>
        <strong>Total:</strong>
      </Table.Summary.Cell>
      <Table.Summary.Cell index={3}>
        <strong style={{ color: "#1890ff" }}>
          {Number(totalDr || 0).toFixed(2)}
        </strong>
      </Table.Summary.Cell>
      {props.columnsVisible?.amount_cr !== false && (
        <Table.Summary.Cell index={4}>
          <strong style={{ color: "#52c41a" }}>
            {Number(totalCr || 0).toFixed(2)}
          </strong>
        </Table.Summary.Cell>
      )}
      <Table.Summary.Cell index={5} />
    </Table.Summary.Row>
  );

  return (
    <Modal
      title={props.columnsVisible?.page || "Voucher Entry"}
      open={props.visible}
      onCancel={props.onClose}
      width={1100}
      footer={null}
      destroyOnClose
    >
      <Form
        form={form}
        ref={formRef}
        onFinish={handleSubmit}
        layout="vertical"
        initialValues={{
          voucher_date:
            props.mode === "post" ? moment() : moment(props.item?.voucher_date),
          account_no: props.item?.account_no,
          description: props.item?.description,
        }}
      >
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={12}>
            <Form.Item
              label="Voucher Date"
              name="voucher_date"
              rules={[
                { required: true, message: "Please select voucher date" },
              ]}
            >
              <DatePicker
                format={dateFormat}
                style={{ width: "100%" }}
                placeholder="Select Date"
              />
            </Form.Item>

            {props.page_mode !== "JV" && (
              <Form.Item
                label="Primary Account"
                name="account_no"
                rules={[{ required: true, message: "Please select account" }]}
              >
                <Select
                  showSearch
                  allowClear
                  placeholder="Select Account"
                  filterOption={(input, option) => {
                    const searchText = input.toLowerCase();
                    const optionText = option.children.toString().toLowerCase();
                    return optionText.includes(searchText);
                  }}
                >
                  {props.accounts?.map((item) => (
                    <Select.Option
                      key={item.account_no}
                      value={item.account_no}
                    >
                      {item.account_no} - {item.account_name}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            )}
          </Col>

          <Col xs={24} sm={12}>
            <Form.Item
              label="Description"
              name="description"
              rules={[{ required: true, message: "Please enter description" }]}
            >
              <Input.TextArea
                rows={3}
                placeholder="Enter voucher description"
              />
            </Form.Item>
          </Col>
        </Row>

        <div style={{ marginTop: 24 }}>
          <Table
            dataSource={dataSource}
            columns={visibleColumns}
            pagination={false}
            size="small"
            bordered
            summary={renderSummary}
            scroll={{ x: 800 }}
            rowKey="key"
          />
        </div>

        {props.page_mode === "JV" && (
          <div
            style={{
              marginTop: 16,
              padding: 12,
              backgroundColor: totalCr !== totalDr ? "#fff2f0" : "#f6ffed",
              border: `1px solid ${
                totalCr !== totalDr ? "#ffccc7" : "#b7eb8f"
              }`,
              borderRadius: 6,
            }}
          >
            <Row justify="space-between" align="middle">
              <Col>
                <span
                  style={{
                    color: totalCr !== totalDr ? "#ff4d4f" : "#52c41a",
                    fontWeight: "bold",
                  }}
                >
                  {totalCr === totalDr ? "✓ Balanced" : "⚠ Not Balanced"}
                </span>
              </Col>
              <Col>
                <span>
                  Difference:{" "}
                  <strong>{Math.abs(totalCr - totalDr).toFixed(2)}</strong>
                </span>
              </Col>
            </Row>
          </div>
        )}

        <Row justify="end" gutter={[16, 0]} style={{ marginTop: 24 }}>
          <Col>
            <Button onClick={props.onClose} size="large">
              Cancel
            </Button>
          </Col>
          <Col>
            <Button
              type="primary"
              htmlType="submit"
              loading={loading}
              size="large"
            >
              {props.mode === "post" ? "Save" : "Update"}
            </Button>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default FormModalJournal;
